import { useEffect } from "react";
import { z } from "zod";

import { useContract } from "@/api/contract-query";
import useAuthStore from "@/store/auth";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

const appQuerySchema = z.object({
	contractCode: z.string().or(z.number()).optional(),
	contractId: z.string().optional(),
	productId: z.string().optional()
});
export const Route = createFileRoute("/query")({
	component: RouteComponent,
	validateSearch: appQuerySchema
});

function RouteComponent() {
	const { contractId, productId, contractCode } = Route.useSearch();
	const user = useAuthStore(state => state.user);

	void useContract({ contractId, contractCode });

	const navigate = useNavigate();

	useEffect(() => {
		if (!user) {
			navigate({ from: "/query", to: "/sign-in" });
			return;
		}
		if (contractId || contractCode) {
			user.userType === "BUYER"
				? navigate({ from: "/query", to: "/buyer/home", search: { contractCode, contractId } })
				: navigate({ from: "/query", to: `/vendor/contract/${contractId ?? ""}` });
			return;
		}
		if (productId) {
			user.userType === "BUYER"
				? navigate({ from: "/query", to: "/buyer/home" })
				: navigate({ from: "/query", to: `/vendor/product/${productId}` });
			return;
		}

		if (!contractId && !productId) {
			navigate({ from: "/query", to: "/sign-in" });
		}
	}, [user, contractId, productId, navigate, contractCode]);

	return (
		<div className="flex flex-col items-center justify-center gap-4 h-screen w-screen">
			<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
		</div>
	);
}
